import { DomainFilterType } from "src/app/model/enum/observations/domain-filter-type.enum";
import { Subdomain } from "src/app/model/enum/observations/subdomain.enum";
import { SCRIPTING_TOOL_TAB } from "src/app/observations/formal/formal-evidence/formal-evidence-base/formal-evidence-base.component";
import { LazyLoadedStates, LazyLoadedStatesManager } from '@edl-development/edl-common';

export const FormalLazyLoadedStates = new LazyLoadedStatesManager<{ 
    base: LazyLoadedStates,
    formalDashboard: LazyLoadedStates,
    formalDashboardView: LazyLoadedStates,
    formalPreObservation: LazyLoadedStates,
    formalPostObservation: LazyLoadedStates,
    formalSummary: LazyLoadedStates,
    formalEvidence: LazyLoadedStates
}> ({
    base: {
        name: 'authenticated.user-summary.formal',
        url: '/formal',
        abstract: true
    },
    formalDashboard: {
        name: 'authenticated.user-summary.formal.dashboard',
        url: '/dashboard/:userId/:observationId',
        abstract: true,
    },
    formalDashboardView: {
        name: 'authenticated.user-summary.formal.dashboard.view',
        url: '/view'
    },
    formalPreObservation: {
        name: 'authenticated.user-summary.formal.dashboard.preobservation',
        url: '/preobservation',
    },
    formalPostObservation: {
        name: 'authenticated.user-summary.formal.dashboard.postobservation',
        url: '/postobservation',
    },
    formalSummary: {
        name: 'authenticated.user-summary.formal.dashboard.summary',
        url: '/summary'
    },
    formalEvidence: {
        name: 'authenticated.user-summary.formal.dashboard.evidence',
        url: '/evidence/:tabIndex?filterType&currentSubdomain',
        params: {
            tabIndex: {
                raw: true,
                dynamic: true,
                type: 'int',
                value: SCRIPTING_TOOL_TAB
            },
            filterType: {
                raw: true,
                dynamic: true,
                type: 'int',
                value: DomainFilterType.ALL
            },
            currentSubdomain: {
                raw: true,
                dynamic: true,
                type: 'string',
                value: Subdomain.CONTENT_KNOWLEDGE
            },
        },
    }
},
() => import('src/app/observations/formal/formal.module')
    .then((result: { FormalModule: any }) => result.FormalModule)
);
